export default __webpack_public_path__ + "static/media/hero-level-4-chars-desk.b9ec35d9.webp";